
import React, { useEffect, useState } from 'react';
import { Button } from "components/atoms";
import chevron from 'assets/SVG/chevron-up.png';
import { AnimatePresence, motion } from 'framer-motion';
import { useWindowScroll, useWindowSize } from 'react-use';
import { getLocalAsset } from 'utils/getLocalAsset';


export const ScrollToTopButton = () => {
  const { height } = useWindowSize();
  const { y } = useWindowScroll();
  const [scrollBtn, setScrollBtn] = useState(false);

  /** 
Scroll Button needs to be conditionally visible
*/
  useEffect(() => {
    const page = document.getElementById('page');
    const pageTop = () => page && page.getBoundingClientRect().top
    const aureconFooter = document.getElementById('aurecon-footer');
    const footerTop = () => aureconFooter && aureconFooter.getBoundingClientRect().top

    const show = pageTop() < -20 && footerTop() > height;
    if (!scrollBtn && show) {
      setScrollBtn(true)
    }
    else if (scrollBtn && !show) {
      setScrollBtn(false)
    }

  }, [y])


  return (
    <AnimatePresence>
      {scrollBtn &&
        <motion.div
          initial={{ opacity: 0, x: 200 }}
          animate={{
            opacity: 1, x: 0, transition: {
              type: "tween"
            }
          }}
          exit={{ x: 200, opacity: 0 }}
          style={{
            zIndex: 1100,
            position: 'fixed',
            right: 0,
            bottom: 0,
            margin: '15px'
          }}
        >
          <Button
            className="scroll-to-top"
            onClick={() => window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            })} buttonStyle="scrollBtn"><img alt="scroll-to-top-button" width="30" src={chevron} /></Button>
        </motion.div>}
    </AnimatePresence>
  )
};